export const OPTIONS = [
  { value: 'Import Directory (Google)', label: 'Import Directory (Google)' },
  { value: 'Import a CSV file', label: 'Import a CSV file' },
  { value: 'Input Manually', label: 'Input Manually' },
];
